import React, {
  useState,
  useEffect,
  useContext,
  forwardRef,
  useRef,
} from "react";
import { ViewGridIcon } from "@heroicons/react/solid";
import NewSeat from "../containers/NewSeat";
import Context from "../context/context";
import { openDB } from "idb";
import NewSection from "../containers/NewSection";
import { CSS } from "@dnd-kit/utilities";

import {
  closestCenter,
  DndContext,
  DragOverlay,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  useSortable,
  SortableContext,
  sortableKeyboardCoordinates,
  rectSortingStrategy,
} from "@dnd-kit/sortable";
import { Delete } from "@mui/icons-material";
import axios from "axios";

let seatsLocalState = [];
const MasterMenuTables = ({
  item,
  isNewSeatAdded,
  newSectionCreated,
  setNewSectionCreated,
  isSeatModified,
  setIsSeatModified,
  sectionDragged,
  selectedMenu,
  seatsAttachedToMenu,
  setSeatsAttachedToMenu,
  selectedValue,
  setSelectedValue,
  brand_uuid,
}) => {
  const [items, setItems] = useState(null);
  const [seats, setSeats] = useState(null);
  const [activeId, setActiveId] = useState(null);
  const [deletePopup, setDeletePopup] = useState(null);

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const [isNewOpen, setIsNewOpen] = useState(false);

  const context = useContext(Context);
  const { generateMenues, updateUnSync } = context;

  const generateMenuTimerRef = useRef(null);
  const generateMenuesTimer = () => {
    clearTimeout(generateMenuTimerRef?.current);
    generateMenuTimerRef.current = setTimeout(() => generateMenues(), 3000);
  };

  useEffect(() => {
    async function getDataFromIndexdDb() {
      const db = await openDB(
        "FoodDo",
        +localStorage?.getItem("IDBVersion") || 1
      );
      const indSeats = await db
        ?.transaction("seats", "readonly")
        ?.objectStore("seats");
      let currentSeats = await indSeats?.getAll();
      currentSeats?.sort((a, b) => {
        if (+a?.seat_sort_order < +b?.seat_sort_order) {
          return -1;
        }
        if (+a?.seat_sort_order > +b?.seat_sort_order) {
          return 1;
        }
        return 0;
      });
      seatsLocalState = await currentSeats;
      setSeats(currentSeats);

      currentSeats = currentSeats?.filter(
        (i) => i?.section_uuid === item?.section_uuid
      );
      setItems(currentSeats?.map((i) => i.seat_uuid));
    }
    getDataFromIndexdDb();

    return () => (seatsLocalState = []);
  }, [isNewSeatAdded, isSeatModified, item, newSectionCreated, sectionDragged]);
  const DeleteSeat = async () => {
    const response = await axios({
      method: "delete",
      url: "https://api.myfooddo.com/seat/deleteSeat",
      data: { seat_uuid: deletePopup.seat_uuid },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    console.log("activity", response);
    if (response.data.success) {
      const db = await openDB(
        "FoodDo",
        +localStorage?.getItem("IDBVersion") || 1
      );
      const indSeats = await db
        ?.transaction("seats", "readwrite")
        ?.objectStore("seats");
      await indSeats.delete(deletePopup.seat_uuid);
      setDeletePopup(response.data.result);
    } else {
      setDeletePopup(response.data.result);
    }
  };
  const handleUpdate = async (data) => {
    const db = await openDB(
      "FoodDo",
      +localStorage?.getItem("IDBVersion") || 1
    );
    const indSeats = await db
      ?.transaction("seats", "readwrite")
      ?.objectStore("seats");
    let count;

    data?.forEach(async (el) => {
      const tx = await indSeats?.get(`${el?.seat_uuid}`);
      const data = {
        ...tx,
        seat_sort_order: el?.seat_sort_order,
      };
      await indSeats?.put(data);
      count++;

      if (count === data.length) generateMenuesTimer();

      handleUnsyncFileUpdate(data);
    });
    // setIsSeatModified(uuid());
  };

  const handleUnsyncFileUpdate = async (data) => {
    const db = await openDB(
      "FoodDo",
      +localStorage?.getItem("IDBVersion") || 1
    );
    const indSeats = await db
      ?.transaction("unsynced_files", "readwrite")
      ?.objectStore("unsynced_files");
    const ndata = {
      ...data,
      RECON_TIME: Date?.now(),
      IDENTIFIER: "seat-edit:" + data?.seat_uuid,
    };
    await indSeats?.put(ndata);
    handleReconciliation(ndata);
    updateUnSync();
  };

  // Adding seat in reconciliation collection in IndexedDB
  const handleReconciliation = async (data) => {
    const db = await openDB(
      "FoodDo",
      +localStorage?.getItem("IDBVersion") || 1
    );
    const tx = await db
      ?.transaction("reconciliation", "readwrite")
      ?.objectStore("reconciliation");
    const allReconRecords = await tx?.getAll();

    const seatsJsonExists = allReconRecords?.find(
      (curr) => curr?.IDENTIFIER === "seats"
    );
    if (seatsJsonExists) {
      const seats = seatsJsonExists?.details?.filter(
        (seat) => seat?.seat_uuid !== data?.seat_uuid
      );
      const editData = {
        ...seatsJsonExists,
        details: [
          ...seats,
          {
            seat_uuid: data?.seat_uuid,
            RECON_TIME: data?.RECON_TIME,
          },
        ],
      };
      await tx?.put(editData);
    } else {
      const newdata = {
        IDENTIFIER: "seats",
        details: [
          {
            seat_uuid: data?.seat_uuid,
            RECON_TIME: data?.RECON_TIME,
          },
        ],
      };
      await tx?.add(newdata);
    }
  };

  return (
    <div className="master-menu-tables">
      <div className="table-heading">
        <h1>{item?.section_name}</h1>
      </div>

      {items && seats && (
        <DndContext
          sensors={sensors}
          collisionDetection={closestCenter}
          onDragStart={handleDragStart}
          onDragEnd={handleDragEnd}
        >
          <SortableContext items={items} strategy={rectSortingStrategy}>
            <div className="content">
              {items?.map((id, i) => {
                const seat = seats?.find((j) => j?.seat_uuid === id);
                if (seat)
                  return (
                    <SortableItem
                      key={i}
                      id={seat?.seat_uuid}
                      seat={seat}
                      value={item}
                      title={seat?.seat_name}
                      activeId={activeId}
                      seats={seats}
                      setSeats={setSeats}
                      selectedMenu={selectedMenu}
                      setIsSeatModified={setIsSeatModified}
                      brand_uuid={brand_uuid}
                      setDeletePopup={setDeletePopup}
                    />
                  );
                else return "";
              })}
            </div>
          </SortableContext>
          <DragOverlay>
            {activeId ? (
              <Item
                id={activeId}
                cardClass={"drag-overlay"}
                seat={seats?.find((o) => o.seat_uuid === activeId)}
                title={seats?.find((o) => o.seat_uuid === activeId)?.seat_name}
                selectedMenu={selectedMenu}
              />
            ) : null}
          </DragOverlay>
        </DndContext>
      )}

      {isNewOpen && selectedValue?.section_name && (
        <NewSection
          order={selectedValue?.section_sort_order}
          close={() => setIsNewOpen(!isNewOpen)}
          UUID={selectedValue?.UUID}
          value={selectedValue?.section_name}
          id={selectedValue?.section_uuid}
          setNewSectionCreated={setNewSectionCreated}
        />
      )}
      {deletePopup && (
        <div className="newCategory">
          <div className="newCatContainer">
            <div className="newCatContainer_header">
              <h2>
                {deletePopup?.seat_name
                  ? `Delete Seat ${deletePopup.seat_name} ?`
                  : deletePopup}
              </h2>
              {/* <XIcon className='closeicon' onClick={close} /> */}
            </div>
            <div
              className="newCatContainer2"
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <button onClick={() => setDeletePopup(null)}>
                {deletePopup?.seat_name ? "Cancel" : "Okay"}
              </button>
              {deletePopup?.seat_name ? (
                <button onClick={() => DeleteSeat()}>Confirm</button>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );

  function handleDragStart(event) {
    const { active } = event;
    setActiveId(active?.id);
  }

  function handleDragEnd(event) {
    const { active, over } = event;

    if (active?.id !== over?.id) {
      const oldIndex = items?.indexOf(active.id);
      const newIndex = items?.indexOf(over.id);

      let updatedItems = arrayMove(items, oldIndex, newIndex);
      setItems(updatedItems);

      handleUpdate(
        updatedItems?.map((id, i) => {
          const seat = seats.find((s) => s.seat_uuid === id);
          return {
            ...seat,
            seat_sort_order: i,
          };
        })
      );
    }
    setActiveId(null);
  }
};

export default MasterMenuTables;

const SortableItem = ({
  id,
  title,
  activeId,
  seat,
  setIsSeatModified,
  selectedMenu,
  setSeats,
  seats,
  brand_uuid,
  setDeletePopup,
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS?.Transform?.toString(transform),
    transition,
  };

  const context = useContext(Context);
  const { generateMenues, setUnAuthPopup, updateUnSync } = context;
  const [isUpdateSeatsOpen, setIsUpdateSeatsOpen] = useState(false);

  const noWarning = () => {
    setUnAuthPopup(true);
    setTimeout(() => setUnAuthPopup(false), 3000);
  };
  const close = (e) => {
    setIsUpdateSeatsOpen(!isUpdateSeatsOpen);
  };

  const generateMenuTimerRef = useRef(null);
  const generateMenuesTimer = () => {
    clearTimeout(generateMenuTimerRef?.current);
    generateMenuTimerRef.current = setTimeout(() => generateMenues(), 3000);
  };

  const updateSeatsData = async (seatData) => {
    const db = await openDB(
      "FoodDo",
      +localStorage?.getItem("IDBVersion") || 1
    );
    const tx = db?.transaction("seats", "readwrite")?.objectStore("seats");

    let count = 0;
    seatData?.map(async (data) => {
      await tx?.put(data);
      count++;
      if (count === seatData?.length) generateMenuesTimer();
    });
  };

  const handleSeatSelection = async () => {
    // console?.log("seat", seat)
    let SData = await seatsLocalState?.map((item) => {
      if (item?.seat_uuid === seat?.seat_uuid) {
        let menu_details =
          item.menu_details?.filter((i) => i.brand_uuid !== brand_uuid) || [];
        if (
          !item.menu_details?.find(
            (i) =>
              i.brand_uuid === brand_uuid &&
              i.menu_uuid === selectedMenu?.menu_uuid
          )
        )
          menu_details.push({ brand_uuid, menu_uuid: selectedMenu?.menu_uuid });
        return {
          ...item,
          menu_details,
        };
      } else return item;
    });
    seatsLocalState = [...SData];
    await setSeats(SData);
    await updateSeatsData(SData);
    await handleUnsyncedFile({
      ...seat,
      menu_details:
        seat?.menu_details?.length === 0
          ? [
              {
                brand_uuid: selectedMenu?.brand_uuid,
                menu_uuid: selectedMenu?.menu_uuid,
              },
            ]
          : seat?.menu_details[0]?.menu_uuid === selectedMenu?.menu_uuid
          ? []
          : [
              {
                brand_uuid: selectedMenu?.brand_uuid,
                menu_uuid: selectedMenu?.menu_uuid,
              },
            ],
    });
  };

  const handleUnsyncedFile = async (data) => {
    const db = await openDB(
      "FoodDo",
      +localStorage?.getItem("IDBVersion") || 1
    );
    const ndata = {
      RECON_TIME: new Date()?.getTime()?.toString(),
      ...data,
      IDENTIFIER: "seat-edit:" + data?.seat_uuid,
    };
    const tx = db
      ?.transaction("unsynced_files", "readwrite")
      ?.objectStore("unsynced_files");
    await tx?.put(ndata);
    await handleReconciliation(ndata);
    updateUnSync();
  };

  const handleReconciliation = async (data) => {
    const db = await openDB(
      "FoodDo",
      +localStorage?.getItem("IDBVersion") || 1
    );
    const tx = await db
      ?.transaction("reconciliation", "readwrite")
      ?.objectStore("reconciliation");
    const allReconRecords = await tx?.getAll();

    const sectionsJsonExists = allReconRecords?.find(
      (curr) => curr?.IDENTIFIER === "seats"
    );
    if (sectionsJsonExists) {
      const sections = sectionsJsonExists?.details?.filter(
        (section) => section?.seat_uuid !== data?.seat_uuid
      );
      const editData = {
        ...sectionsJsonExists,
        details: [
          ...sections,
          {
            seat_uuid: data?.seat_uuid,
            RECON_TIME: data?.RECON_TIME,
          },
        ],
      };
      await tx?.put(editData);
    } else {
      const newdata = {
        IDENTIFIER: "seats",
        details: [
          {
            seat_uuid: data?.seat_uuid,
            RECON_TIME: data?.RECON_TIME,
          },
        ],
      };
      await tx?.add(newdata);
    }
  };

  return (
    <>
      <div
        onClick={(e) => {
          e?.stopPropagation();
          handleSeatSelection();
        }}
        className={`multi-select-card ${
          activeId === seat?.seat_uuid ? "active" : ""
        }`}
      >
        <Item
          id={id}
          seat={seat}
          title={title}
          selectedMenu={selectedMenu}
          noWarning={noWarning}
          close={close}
          ref={setNodeRef}
          style={style}
          {...attributes}
          {...listeners}
          setDeletePopup={setDeletePopup}
        />
      </div>

      {isUpdateSeatsOpen && (
        <NewSeat
          setIsSeatModified={setIsSeatModified}
          value={seat}
          close={close}
        />
      )}
    </>
  );
};

const Item = forwardRef(
  (
    {
      seat,
      title,
      selectedMenu,
      noWarning,
      close,
      cardClass,
      setDeletePopup,
      style,
      ...props
    },
    ref
  ) => {
    let restrictions =
      JSON?.parse(sessionStorage?.getItem("restrictions")) || [];

    return (
      <div ref={ref} style={style} className={`card rounded ${cardClass}`}>
        <div
          style={{
            color: "red",
            position: "absolute",
            right: "5px",
            bottom: "5px",
            cursor: "pointer",
          }}
          onClick={(e) => {
            e.stopPropagation();
            setDeletePopup(seat);
          }}
        >
          <Delete style={{ fontSize: "20px" }} />
        </div>
        <ViewGridIcon {...props} className="gridviewIco" />
        <p style={{ height: 75 }} className="title2">
          {title}
        </p>
        <div
          className={`horizontal-line ${seat?.seat_uuid} ${
            seat?.menu_details?.length &&
            seat?.menu_details?.find(
              (i) => i.menu_uuid === selectedMenu?.menu_uuid
            )
              ? "red"
              : ""
          }`}
        ></div>
        <div className="card-actions">
          <button
            onClick={
              +restrictions[0]?.other_menu_and_seat_new_edit_seat_section === 0
                ? () => noWarning()
                : (e) => {
                    close(e);
                    e?.stopPropagation();
                  }
            }
          >
            Edit
          </button>
        </div>
      </div>
    );
  }
);
